import React from 'react';

const LinearProgress = () => {
  return (
    <div className="linear-progress-container">
      <div className="linear-progress-bar"></div>
    </div>
  );
};

export default LinearProgress;
